import { render } from "./IntersectionObserver.vue?vue&type=template&id=2a3cf0d8"
import script from "./IntersectionObserver.vue?vue&type=script&lang=js"
export * from "./IntersectionObserver.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/IntersectionObserver.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a3cf0d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a3cf0d8', __exports__)) {
    api.reload('2a3cf0d8', __exports__)
  }
  
  module.hot.accept("./IntersectionObserver.vue?vue&type=template&id=2a3cf0d8", () => {
    api.rerender('2a3cf0d8', render)
  })

}


export default __exports__